import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-without-permission',
  templateUrl: './employee-without-permission.component.html',
  styleUrls: ['./employee-without-permission.component.css']
})
export class EmployeeWithoutPermissionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
